import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes, PropType } from 'vue'
import type Masker from './masker.vue'

// 合并 linkProps 和 MaskerProps
export const maskerProps = buildProps({
  /**
   * @description 设置遮罩是否显示，可以使用 v-model 双向绑定
   */
  active: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 设置是否可以点击遮罩层关闭
   */
  closable: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 控制遮罩是否允许背景内容交互
   */
  permeable: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 是否禁止使用 ESC 键关闭
   */
  disableEsc: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 控制遮罩是否被移动到 <body> 元素下
   */
  transfer: {
    type: Boolean,
    default: true,
  },
  onBeforeClose: {
    type: Function as PropType<() => Promise<boolean> | boolean>,
    default: undefined,
  },
  onResize: {
    type: Function as PropType<() => void>,
    default: undefined,
  },
} as const)

export type MaskerPropsType = ExtractPropTypes<typeof maskerProps>

export const maskerEmits = {
  click: (evt: MouseEvent) => evt instanceof MouseEvent,
  'before-close': (shouldClose: boolean) => typeof shouldClose === 'boolean',
  resize: () => true,
}

export type MaskerEmits = typeof maskerEmits

export type MaskerInstance = InstanceType<typeof Masker>
